module.exports = __webpack_public_path__ + "static/media/398.fee2a305.jpg";